import { Star, BadgeCheck, MessageCircle, Phone, Video, WalletIcon, CreditCard, Banknote, Play } from "lucide-react";
import { Button } from "./button";
import { usdToLocalLabel } from "../../utilities/currency";
import { readingLine } from "../../utilities/currency";
import React from "react";
export function Hero({ hero }) {
    return (
        <section className="relative w-full">
          <div className="relative h-[420px] md:h-[520px] w-full overflow-hidden">
            <img
              src="../../../team.png"
              alt="Åndelig bakgrunn"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
            <div className="relative z-10 h-full flex items-center">
              <div className="px-4 md:px-10 max-w-6xl">
                {/* <div className="inline-flex items-center gap-2 rounded-full bg-yellow-100/90 text-yellow-800 px-3 py-1 text-sm font-semibold mb-3">
                  <Star className="w-4 h-4" /> 5.0
                </div>
                <p className="text-purple-200 mt-1 text-lg">🔮❤️ {hero.tag} ❤️🔮</p>
                <p className="mt-4 text-white/90 max-w-2xl text-sm md:text-base">{hero.blurb}</p> */}
                <h2 className="text-3xl md:text-5xl font-extrabold text-white leading-tight flex items-center gap-3">
                  {hero.name}
                </h2>
                <div className="mt-5 flex items-center gap-4">
                  <Button className="bg-pink-500 hover:bg-pink-600 text-white rounded-full px-5 py-2">{hero.getReading}</Button>
                  <div className="flex gap-4 text-purple-200">
                    <MessageCircle className="w-6 h-6" />
                    <Phone className="w-6 h-6" />
                    <Video className="w-6 h-6" />
                  </div>
                </div>
                <div className="mt-4 text-white/95 text-sm font-medium flex items-center gap-6">
                  <span>
                    {hero.from} <span className="font-bold">{usdToLocalLabel("$5.99/min")}</span>
                  </span>
                  {/* <span className="text-white/80">{readingLine(15810, 2018)}</span> */}
                </div>
                {/* <div className="mt-2 flex items-center gap-2">
                  <span className="text-xs font-semibold rounded-full px-2 py-1 bg-purple-200/90 text-purple-900 flex items-center gap-1">
                    <WalletIcon className="w-3 h-3" /> Vipps MobilePay
                  </span>
                  <span className="text-xs font-semibold rounded-full px-2 py-1 bg-blue-200/90 text-blue-900 flex items-center gap-1">
                    <CreditCard className="w-3 h-3" /> Kort
                  </span>
                  <span className="text-xs font-semibold rounded-full px-2 py-1 bg-amber-200/90 text-amber-900 flex items-center gap-1">
                    <Banknote className="w-3 h-3" /> NOK
                  </span>
                </div> */}
              </div>
            </div>
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur rounded-full p-2 shadow">
              <Play className="w-5 h-5 text-purple-700" />
            </div>
          </div>
        </section>
      );
}